import _toConsumableArray from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
  _excluded2 = ["show", "appear", "unmount"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import m, { Fragment as Q, createContext as Y, useContext as X, useEffect as y, useMemo as Z, useRef as c, useState as W } from "react";
import { Features as de, forwardRefWithAs as q, render as $, RenderStrategy as E } from '../../utils/render.js';
import { OpenClosedProvider as fe, State as b, useOpenClosed as ee } from '../../internal/open-closed.js';
import { match as F } from '../../utils/match.js';
import { useIsMounted as me } from '../../hooks/use-is-mounted.js';
import { useIsoMorphicEffect as ce } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as A } from '../../hooks/use-latest-value.js';
import { useServerHandoffComplete as te } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as ne } from '../../hooks/use-sync-refs.js';
import { useTransition as pe } from '../../hooks/use-transition.js';
import { useEvent as S } from '../../hooks/use-event.js';
import { useDisposables as he } from '../../hooks/use-disposables.js';
import { classNames as ve } from '../../utils/class-names.js';
import { useFlags as ge } from '../../hooks/use-flags.js';
function x() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return t.split(" ").filter(function (n) {
    return n.trim().length > 1;
  });
}
var I = Y(null);
I.displayName = "TransitionContext";
var Ce = function (r) {
  return r.Visible = "visible", r.Hidden = "hidden", r;
}(Ce || {});
function Ee() {
  var t = X(I);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function be() {
  var t = X(_);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
var _ = Y(null);
_.displayName = "NestingContext";
function M(t) {
  return "children" in t ? M(t.children) : t.current.filter(function (_ref) {
    var n = _ref.el;
    return n.current !== null;
  }).filter(function (_ref2) {
    var n = _ref2.state;
    return n === "visible";
  }).length > 0;
}
function re(t, n) {
  var r = A(t),
    o = c([]),
    N = me(),
    H = he(),
    p = S(function (s) {
      var _F;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : E.Hidden;
      var a = o.current.findIndex(function (_ref3) {
        var i = _ref3.el;
        return i === s;
      });
      a !== -1 && (F(e, (_F = {}, _defineProperty(_F, E.Unmount, function () {
        o.current.splice(a, 1);
      }), _defineProperty(_F, E.Hidden, function () {
        o.current[a].state = "hidden";
      }), _F)), H.microTask(function () {
        var i;
        !M(o) && N.current && ((i = r.current) == null || i.call(r));
      }));
    }),
    P = S(function (s) {
      var e = o.current.find(function (_ref4) {
        var a = _ref4.el;
        return a === s;
      });
      return e ? e.state !== "visible" && (e.state = "visible") : o.current.push({
        el: s,
        state: "visible"
      }), function () {
        return p(s, E.Unmount);
      };
    }),
    h = c([]),
    v = c(Promise.resolve()),
    T = c({
      enter: [],
      leave: [],
      idle: []
    }),
    g = S(function (s, e, a) {
      h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          i = _ref6[0];
        return i !== s;
      })), n == null || n.chains.current[e].push([s, new Promise(function (i) {
        h.current.push(i);
      })]), n == null || n.chains.current[e].push([s, new Promise(function (i) {
        Promise.all(T.current[e].map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            l = _ref8[0],
            R = _ref8[1];
          return R;
        })).then(function () {
          return i();
        });
      })]), e === "enter" ? v.current = v.current.then(function () {
        return n == null ? void 0 : n.wait.current;
      }).then(function () {
        return a(e);
      }) : a(e);
    }),
    f = S(function (s, e, a) {
      Promise.all(T.current[e].splice(0).map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          i = _ref10[0],
          l = _ref10[1];
        return l;
      })).then(function () {
        var i;
        (i = h.current.shift()) == null || i();
      }).then(function () {
        return a(e);
      });
    });
  return Z(function () {
    return {
      children: o,
      register: P,
      unregister: p,
      onStart: g,
      onStop: f,
      wait: v,
      chains: T
    };
  }, [P, p, o, g, f, T, v]);
}
function Se() {}
var xe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ie(t) {
  var r;
  var n = {};
  var _iterator = _createForOfIteratorHelper(xe),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var o = _step.value;
      n[o] = (r = t[o]) != null ? r : Se;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return n;
}
function Pe(t) {
  var n = c(ie(t));
  return y(function () {
    n.current = ie(t);
  }, [t]), n;
}
var Re = "div",
  oe = de.RenderStrategy;
function ye(t, n) {
  var _F3;
  var r = t.beforeEnter,
    o = t.afterEnter,
    N = t.beforeLeave,
    H = t.afterLeave,
    p = t.enter,
    P = t.enterFrom,
    h = t.enterTo,
    v = t.entered,
    T = t.leave,
    g = t.leaveFrom,
    f = t.leaveTo,
    s = _objectWithoutProperties(t, _excluded),
    e = c(null),
    a = ne(e, n),
    i = s.unmount ? E.Unmount : E.Hidden,
    _Ee = Ee(),
    l = _Ee.show,
    R = _Ee.appear,
    d = _Ee.initial,
    _W = W(l ? "visible" : "hidden"),
    _W2 = _slicedToArray(_W, 2),
    u = _W2[0],
    U = _W2[1],
    K = be(),
    L = K.register,
    w = K.unregister,
    j = c(null);
  y(function () {
    return L(e);
  }, [L, e]), y(function () {
    if (i === E.Hidden && e.current) {
      var _F2;
      if (l && u !== "visible") {
        U("visible");
        return;
      }
      return F(u, (_F2 = {}, _defineProperty(_F2, "hidden", function hidden() {
        return w(e);
      }), _defineProperty(_F2, "visible", function visible() {
        return L(e);
      }), _F2));
    }
  }, [u, e, L, w, l, i]);
  var k = A({
      enter: x(p),
      enterFrom: x(P),
      enterTo: x(h),
      entered: x(v),
      leave: x(T),
      leaveFrom: x(g),
      leaveTo: x(f)
    }),
    O = Pe({
      beforeEnter: r,
      afterEnter: o,
      beforeLeave: N,
      afterLeave: H
    }),
    G = te();
  y(function () {
    if (G && u === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [e, u, G]);
  var B = d && !R,
    ae = function () {
      return !G || B || j.current === l ? "idle" : l ? "enter" : "leave";
    }(),
    D = ge(0),
    le = S(function (C) {
      return F(C, {
        enter: function enter() {
          D.addFlag(b.Opening), O.current.beforeEnter();
        },
        leave: function leave() {
          D.addFlag(b.Closing), O.current.beforeLeave();
        },
        idle: function idle() {}
      });
    }),
    ue = S(function (C) {
      return F(C, {
        enter: function enter() {
          D.removeFlag(b.Opening), O.current.afterEnter();
        },
        leave: function leave() {
          D.removeFlag(b.Closing), O.current.afterLeave();
        },
        idle: function idle() {}
      });
    }),
    V = re(function () {
      U("hidden"), w(e);
    }, K);
  pe({
    container: e,
    classes: k,
    direction: ae,
    onStart: A(function (C) {
      V.onStart(e, C, le);
    }),
    onStop: A(function (C) {
      V.onStop(e, C, ue), C === "leave" && !M(V) && (U("hidden"), w(e));
    })
  }), y(function () {
    B && (i === E.Hidden ? j.current = null : j.current = l);
  }, [l, B, u]);
  var J = s,
    Te = {
      ref: a
    };
  return R && l && d && (J = _objectSpread(_objectSpread({}, J), {}, {
    className: ve.apply(void 0, [s.className].concat(_toConsumableArray(k.current.enter), _toConsumableArray(k.current.enterFrom)))
  })), m.createElement(_.Provider, {
    value: V
  }, m.createElement(fe, {
    value: F(u, (_F3 = {}, _defineProperty(_F3, "visible", b.Open), _defineProperty(_F3, "hidden", b.Closed), _F3)) | D.flags
  }, $({
    ourProps: Te,
    theirProps: J,
    defaultTag: Re,
    features: oe,
    visible: u === "visible",
    name: "Transition.Child"
  })));
}
function Ne(t, n) {
  var r = t.show,
    _t$appear = t.appear,
    o = _t$appear === void 0 ? !1 : _t$appear,
    N = t.unmount,
    H = _objectWithoutProperties(t, _excluded2),
    p = c(null),
    P = ne(p, n);
  te();
  var h = ee();
  if (r === void 0 && h !== null && (r = (h & b.Open) === b.Open), ![!0, !1].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  var _W3 = W(r ? "visible" : "hidden"),
    _W4 = _slicedToArray(_W3, 2),
    v = _W4[0],
    T = _W4[1],
    g = re(function () {
      T("hidden");
    }),
    _W5 = W(!0),
    _W6 = _slicedToArray(_W5, 2),
    f = _W6[0],
    s = _W6[1],
    e = c([r]);
  ce(function () {
    f !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), s(!1));
  }, [e, r]);
  var a = Z(function () {
    return {
      show: r,
      appear: o,
      initial: f
    };
  }, [r, o, f]);
  y(function () {
    if (r) T("visible");else if (!M(g)) T("hidden");else {
      var d = p.current;
      if (!d) return;
      var u = d.getBoundingClientRect();
      u.x === 0 && u.y === 0 && u.width === 0 && u.height === 0 && T("hidden");
    }
  }, [r, g]);
  var i = {
      unmount: N
    },
    l = S(function () {
      var d;
      f && s(!1), (d = t.beforeEnter) == null || d.call(t);
    }),
    R = S(function () {
      var d;
      f && s(!1), (d = t.beforeLeave) == null || d.call(t);
    });
  return m.createElement(_.Provider, {
    value: g
  }, m.createElement(I.Provider, {
    value: a
  }, $({
    ourProps: _objectSpread(_objectSpread({}, i), {}, {
      as: Q,
      children: m.createElement(se, _objectSpread(_objectSpread(_objectSpread({
        ref: P
      }, i), H), {}, {
        beforeEnter: l,
        beforeLeave: R
      }))
    }),
    theirProps: {},
    defaultTag: Q,
    features: oe,
    visible: v === "visible",
    name: "Transition"
  })));
}
function He(t, n) {
  var r = X(I) !== null,
    o = ee() !== null;
  return m.createElement(m.Fragment, null, !r && o ? m.createElement(z, _objectSpread({
    ref: n
  }, t)) : m.createElement(se, _objectSpread({
    ref: n
  }, t)));
}
var z = q(Ne),
  se = q(ye),
  De = q(He),
  $e = Object.assign(z, {
    Child: De,
    Root: z
  });
export { $e as Transition };